import { render } from "./MyofficeNav.vue?vue&type=template&id=6a9a998b&scoped=true"
import script from "./MyofficeNav.vue?vue&type=script&lang=js"
export * from "./MyofficeNav.vue?vue&type=script&lang=js"

import "./MyofficeNav.vue?vue&type=style&index=0&id=6a9a998b&lang=css"
import "./MyofficeNav.vue?vue&type=style&index=1&id=6a9a998b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9a998b"]])

export default __exports__